import styled from '@emotion/styled';
import { Button, Divider, Grid, Typography } from '@mui/material';

const ToolbarContainer = styled(Grid)`
  height: 10ch;
  height: fit-content;
`;

const RightGridContainer = styled(Grid)`
  display: flex;
  align-items: center;
  height: 5ch;
  justify-content: flex-end;
`;

const DashboardTypography = styled(Typography)`
  font-family: 'AvenirRoman';
  font-style: normal;
  font-weight: 400;
  font-size: 4ch;
  color: #53565a;
`;

const ResetTypography = styled(Typography)`
  font-family: 'AvenirRoman';
  font-style: normal;
  font-weight: 400;
  font-size: 2ch;
  line-height: 3ch;
  color: #000000;
  text-transform: none;
`;

const StyledDivider = styled(Divider)`
  height: 3ch;
  background-color: grey;
  margin: auto 1ch;
`;

const LeftGridContainer = styled(Grid)``;

export {
  ToolbarContainer,
  LeftGridContainer,
  RightGridContainer,
  DashboardTypography,
  ResetTypography,
  StyledDivider,
  Button,
};
